import React from "react";
import styles from "./CtaButton.module.css";
const CtaButton = ({ cta, children }) => {
  return (
    <div className={`${styles.button} ${cta ? styles.ctabutton : styles.noncta}`}>
      {children}
    </div>
  );
};

export default CtaButton;
